module.exports = __webpack_public_path__ + "media/images/logo-2778ae3f52cbf3c4157b20f6004e1fbb.png";